import { ref, watch } from "vue"
import ComponentesService from "@/services/ComponentesService"
import StatusComponenteConstant from "@/constants/StatusComponenteConstant";

class ComponenteFormularioService {
    setup({ opcoes, respostaObrigatoria, etapaComponente, identificador, modulo, resumoModulos }) {
        const componentes = ref(opcoes);
        const statusResposta = ref(StatusComponenteConstant.PENDENTE.chave);

        if(!resumoModulos) {
            statusResposta.value = this._validaStatusRespostaComponente(respostaObrigatoria, componentes.value)
            ComponentesService.salvarStatusComponente(etapaComponente, identificador, modulo, statusResposta.value);  

            watch(componentes, (novoValor) => {
                statusResposta.value = this._validaStatusRespostaComponente(respostaObrigatoria, novoValor)
                ComponentesService.salvarStatusComponente(etapaComponente, identificador, modulo, statusResposta.value);  
            }, { deep: true });
        }

        return { componentes, statusResposta };
    }

    _validaStatusRespostaComponente(respostaObrigatoria, subcomponentes) {
        const componentesObrigatorios = Object.values(subcomponentes).filter(({respostaObrigatoria}) => respostaObrigatoria == true)
        const respostaAlterada = componentesObrigatorios.every(({respostas}) => (respostas != null && respostas != ''))        
        return ComponentesService.validaStatusRespostaComponente(respostaObrigatoria, respostaAlterada)
    }
}

export default new ComponenteFormularioService();